import img1 from '../assets/frequentis.png';
import img2 from '../assets/volkswagen.png';
import img3 from '../assets/asociatia-aeronave.png';
import img4 from '../assets/ergo-direkt.png';
import img5 from '../assets/sparda-bank.png';
import { getContent } from '../store/ContentStore'; 

export const partners = [img1, img2, img3, img4, img5];

export const loadAboutContentEn = () => {
    
    const aboutData = getContent("about.", "en");

    if (!aboutData || !aboutData.en || Object.keys(aboutData.en).length === 0) {
        return { title: '', text: '' };
    }

    const englishLabels = aboutData.en; 
    
  
    const contentObject = {
        title: englishLabels['about.title'] || 'Default Title', 
      
        text: englishLabels['about.description'] || englishLabels['about.text'] || 'Default Description' 
    };

    return contentObject;
};

export const loadAboutContentRo = () => {
    
    const aboutData = getContent("about.", "ro");

    if (!aboutData || !aboutData.ro || Object.keys(aboutData.ro).length === 0) {
        return { title: '', text: '' };
    }

    const romanianLabels = aboutData.ro; 
    
  
    const contentObject = {
        title: romanianLabels['about.title'] || 'Default Title', 
      
        text: romanianLabels['about.description'] || romanianLabels['about.text'] || 'Default Description' 
    };

    return contentObject;
};